import { fragments } from '@/gql'
import gql from 'graphql-tag'
export default gql`
  query SlimLabels ($limit: Int, $filters:[Filter]) {
    SlimLabels: ViLabels (limit: $limit, filters: $filters) {
        ...viLabelProps
        ...objectTrackingProps
    }
  }
  ${fragments.viLabelProps}
  ${fragments.objectTrackingProps}
`